import { Badge, Button, DataTable } from '@commenda/kakashi';

import { IndirectTaxClientTaskHelper } from '../helpers';
import { IndirectTaxClientTask } from '../types';

interface IndirectTaxClientTaskTableProps {
  tasks: IndirectTaxClientTask[];
  corporationId: number;
}

export function IndirectTaxClientTaskTable({
  tasks,
  corporationId,
}: IndirectTaxClientTaskTableProps) {
  // Tax period / due date only exist on filing tasks. Hide those columns
  // entirely when the list is all registration tasks (e.g. the registrations
  // dashboard) so we don't render a column of blanks.
  const hasFilingDetails = tasks.some(
    (task) => task.taxPeriod || task.dueDate
  );

  return (
    <DataTable
      data={tasks}
      columnGroups={[
        {
          id: 'client-task-info',
          columns: [
            {
              accessorKey: 'title',
              header: 'Task',
              title: 'Task',
              showInSelector: false,
              enableSorting: false,
              cell: ({ row }) => (
                <span className="txt-small-medium text-text-primary">
                  {row.original.title}
                </span>
              ),
            },
            ...(hasFilingDetails
              ? [
                  {
                    accessorKey: 'taxPeriod',
                    header: 'Tax period',
                    title: 'Tax period',
                    showInSelector: false,
                    enableSorting: false,
                    cell: ({ row }) =>
                      row.original.taxPeriod ? (
                        <Badge variant="gray" size="sm">
                          {row.original.taxPeriod}
                        </Badge>
                      ) : null,
                  },
                  {
                    accessorKey: 'dueDate',
                    header: 'Due date',
                    title: 'Due date',
                    showInSelector: false,
                    enableSorting: false,
                    cell: ({ row }) =>
                      row.original.dueDate ? (
                        <Badge variant="gray" size="sm">
                          {row.original.dueDate}
                        </Badge>
                      ) : null,
                  },
                ]
              : []),
            {
              accessorKey: 'source',
              header: 'Type',
              title: 'Type',
              showInSelector: false,
              enableSorting: false,
              cell: ({ row }) => (
                <Badge variant="gray" size="sm">
                  {IndirectTaxClientTaskHelper.getTypeBadgeLabel(
                    row.original.source
                  )}
                </Badge>
              ),
            },
            {
              accessorKey: 'status',
              header: 'Status',
              title: 'Status',
              showInSelector: false,
              enableSorting: false,
              cell: ({ row }) =>
                row.original.status === 'IN_PROGRESS' ? (
                  <Badge variant="warning" size="sm">
                    In progress
                  </Badge>
                ) : (
                  <Badge variant="gray" size="sm">
                    Not started
                  </Badge>
                ),
            },
            {
              accessorKey: 'action',
              header: '',
              title: 'Action',
              showInSelector: false,
              enableSorting: false,
              cell: ({ row }) => {
                const task = row.original;
                const href = IndirectTaxClientTaskHelper.getTaskHref(
                  task,
                  corporationId
                );
                const handleAction = () => {
                  if (href) window.location.href = href;
                };
                return (
                  <div className='w-full flex justify-end'>
                    <Button
                      variant="secondary"
                      size="sm"
                      onClick={handleAction}
                      disabled={!href}
                    >
                      {IndirectTaxClientTaskHelper.getActionLabel(task.source)}
                    </Button>
                  </div>
                );
              },
            },
          ],
        },
      ]}
      searchConfig={{ isEnabled: false, columnsToEnableSearchFor: [] }}
      tableViewConfig={{ isEnabled: false, defaultView: 'regular' }}
    />
  );
}
